import { CustomStyle } from "../../GlobalTypes";

// -----------------------------------------------------------------Exports---
export const style: CustomStyle = {
  paper: {
    padding: 32,
  },
  label: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 4,
  },
  formControl: {
    width: "100%",
  },
  buttonBox: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
    marginTop: 32,
  },
  button: {
    marginLeft: 16,
  },
  lineItemRow: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    marginBottom: 16,
  },
};
